import {UIComponent} from "@webfruits/core";
import {CoreServices} from "../../core/CoreServices";
import {IconButton} from "./components/IconButton";
import {Size} from "../../style/Size";

/******************************************************************
 * UISystem
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class UISystem extends UIComponent {

    /******************************************************************
     * Properties
     *****************************************************************/

    private _closeButton: IconButton;

    /******************************************************************
     * Constructor
     *****************************************************************/

    constructor(private _core: CoreServices) {
        super("ui-system");
        this.initCloseButton();
        this.initListeners();
        this._core.state.SELECTED_HOTSPOT.onChangeSignal.add(() => this.onSelectedHotspotChanged());
    }

    /******************************************************************
     * Public Methodes
     *****************************************************************/

    public updateStyles() {
        this.applyStyle({
            position: "absolute",
            pointerEvents: "none",
            width: Size.APP_WIDTH,
            height: Size.APP_HEIGHT
        })
        this._closeButton.applyStyle({
            position: "absolute",
            right: 20,
            top: 20
        })
    }

    /******************************************************************
     * Private Methodes
     *****************************************************************/

    private initCloseButton() {
        this._closeButton = new IconButton("close");
        this._closeButton.hide(true);
        this._closeButton.onClickSignal.add(() => this.onCloseButtonClicked());
        this.addChild(this._closeButton);
    }

    private initListeners() {
        window.addEventListener("click", () => this.onWindowClicked());
    }

    /******************************************************************
     * Events
     *****************************************************************/

    private onCloseButtonClicked() {
        this._core.state.SELECTED_HOTSPOT.reset();
    }

    private onSelectedHotspotChanged() {
        if (this._core.state.SELECTED_HOTSPOT.hasValue()) {
            this._closeButton.show();
        } else {
            this._closeButton.hide();
        }
    }

    private onWindowClicked() {
        if (!this._core.state.SELECTED_HOTSPOT.hasValue()) return;
        this._core.state.SELECTED_HOTSPOT.reset();
    }
}
